import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { personalInfo, projects } from '../mock';

const Projects = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-neutral-950 via-neutral-900 to-neutral-950">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-neutral-950/80 backdrop-blur-md border-b border-gray-800 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-white hover:text-gray-300 transition-colors">
            {personalInfo.name.split(' ').map((word, i) => i === 0 ? word[0] : '').join('')}VT
          </Link>
          <div className="flex items-center gap-6">
            <Link to="/projects" className="text-white font-semibold">Projects</Link>
            <Link to="/about" className="text-neutral-300 hover:text-white transition-colors">About</Link>
            <Link to="/contact">
              <Button variant="outline" className="border-gray-600 text-gray-300 hover:bg-gray-800 hover:text-white">
                Contact Me
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-16 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Projects</h1>
            <p className="text-xl text-neutral-300">A collection of my game development work</p>
          </div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <Link 
                key={project.id} 
                to={`/project/${project.id}`}
                className="group"
              >
                <div className="relative overflow-hidden rounded-lg bg-neutral-900 border-2 border-gray-800 hover:border-gray-600 transition-all duration-300 hover:shadow-2xl hover:shadow-gray-900/50">
                  <div className="relative overflow-hidden aspect-video">
                    <img 
                      src={project.thumbnail} 
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/60 to-transparent opacity-80"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-gray-300 transition-colors">
                      {project.title}
                    </h3>
                    <p className="text-neutral-400 text-sm leading-relaxed">
                      {project.shortDescription}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-neutral-800">
        <div className="max-w-7xl mx-auto text-center text-neutral-400">
          <p>&copy; 2025 {personalInfo.name}. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Projects;
